import { Config } from "next-i18n-router/dist/types"

export const i18nConfig = {
  locales: ["de", "en"],
  defaultLocale: "de",
} as const satisfies Config

export type SupportedLocales = (typeof i18nConfig.locales)[number]
